import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "preset-settings-page__settings-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, " Currency ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsScreenHeader = _resolveComponent("SettingsScreenHeader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_CurrencyForm = _resolveComponent("CurrencyForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_AddCurrencyDialog = _resolveComponent("AddCurrencyDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SettingsScreenHeader, {
      "selected-country-name": _ctx.selectedCountryName,
      "is-save-button-disabled": _ctx.isSaveButtonDisabled,
      "is-loading": _ctx.isCashierConfigListLoading,
      onClose: _ctx.closeSettingsScreen,
      onSubmit: _ctx.submitForm
    }, null, 8 /* PROPS */, ["selected-country-name", "is-save-button-disabled", "is-loading", "onClose", "onSubmit"]),
    _createVNode(_component_el_container, { class: "preset-settings-page__settings-screen__content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          height: "56px",
          class: "preset-settings-page__settings-screen__content-header"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_el_button, {
              icon: _ctx.icons.Plus,
              type: "primary",
              plain: "",
              onClick: _ctx.openAddCurrencyDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.PresetSettingsButtonName.ADD_CURRENCY), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["icon", "onClick"])
          ]),
          _: 1 /* STABLE */
        }),
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          (!_ctx.isCurrencyFormListEmpty)
            ? (_openBlock(), _createBlock(_component_el_main, {
                key: 0,
                class: "preset-settings-page__settings-screen__content-main"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse, {
                    modelValue: _ctx.activeCollapseItems,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeCollapseItems) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyFormList, (value, key, index) => {
                        return (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: key,
                          name: key
                        }, {
                          title: _withCtx(() => [
                            _createVNode(_component_el_text, { size: "large" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(key), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_button, {
                                circle: "",
                                size: "small",
                                icon: _ctx.icons.Delete,
                                onClick: _withModifiers(($event: any) => (_ctx.deleteCurrencyForm(key)), ["stop"])
                              }, null, 8 /* PROPS */, ["icon", "onClick"]),
                              _createVNode(_component_el_button, {
                                circle: "",
                                size: "small",
                                class: "arrow-button",
                                icon: _ctx.icons.ArrowRight
                              }, null, 8 /* PROPS */, ["icon"])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_CurrencyForm, {
                              ref_for: true,
                              ref: element => value.customRef = element,
                              switchers: value.switchers,
                              "settings-form": value.data,
                              rules: _ctx.currencyFormListRules,
                              onOnChangeCurrencyForm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setIsCurrencyFormChanged(true)))
                            }, null, 8 /* PROPS */, ["switchers", "settings-form", "rules"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createBlock(_component_el_main, {
                key: 1,
                class: "preset-settings-page__settings-screen__content-empty"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" While there is nothing, add the presets ")
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_el_button, {
                    icon: _ctx.icons.Plus,
                    type: "primary",
                    onClick: _ctx.openAddCurrencyDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.PresetSettingsButtonName.ADD_CURRENCY), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["icon", "onClick"])
                ]),
                _: 1 /* STABLE */
              }))
        ])), [
          [_directive_loading, _ctx.isCashierConfigListLoading]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_AddCurrencyDialog, {
      modelValue: _ctx.isAddCurrencyDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAddCurrencyDialogVisible) = $event)),
      "currency-list": _ctx.availableCurrencyList,
      onAddCurrencyList: _ctx.addCurrencies
    }, null, 8 /* PROPS */, ["modelValue", "currency-list", "onAddCurrencyList"])
  ]))
}